import React from 'react';

import StackedLayout from 'app/components/layout/StackedLayout';
import MetaTitle from 'app/features/alreadyPremium/MetaTitle';
import HeroBlock from 'app/features/alreadyPremium/heroBlock/HeroBlock';
import SeriesBlock from 'app/features/success/seriesBlock/components/SeriesBlock';
import LatestNewsBlock from 'app/features/alreadyPremium/LatestNewsBlock';
import MangaBlock from 'app/features/alreadyPremium/MangaBlock';
import HelpCenterBlock from 'app/features/alreadyPremium/HelpCenterBlock';

const AlreadyPremium = () => (
  <StackedLayout hasMarginTop>
    <MetaTitle />
    <HeroBlock />
    <SeriesBlock />
    <LatestNewsBlock />
    <MangaBlock />
    <HelpCenterBlock />
  </StackedLayout>
);

export default AlreadyPremium;
